import React, { memo } from 'react';

import TextAvatar from '@components/common/TextAvatar';
import ViewActionTableCell from '@components/common/ViewActionTableCell';

import styles from './ViewOrganizationTableCell.module.scss';

interface IViewOrganizationTableCell {
	onClick: () => void;
	text: string;
	avatarId?: string;
	tooltipLabel?: string;
	styleInline?: React.CSSProperties;
}

const ViewOrganizationTableCell = ({
	onClick,
	text,
	avatarId,
	tooltipLabel,
	styleInline = {},
}: IViewOrganizationTableCell) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.avatar}>
				<TextAvatar
					avatarId={avatarId}
					firstName={text}
					fontSize='10px'
					isProfileLogo
					size='28px'
				/>
			</div>
			<ViewActionTableCell
				isDisabled={Number(text) === 0}
				onClick={onClick}
				styleInline={styleInline}
				text={text}
				tooltipLabel={tooltipLabel}
			/>
		</div>
	);
};

export default memo(ViewOrganizationTableCell);
